import { BoxRequest, StatusKey as BoxRequestStatusKey } from '@/models/BoxRequest';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<RequestStatusFilter>({})
export default class RequestStatusFilter extends Vue {
  @Prop()
  private value!: Item;

  private handleInput(item: Item): void {
    this.$emit('input', item);
  }

  private get items(): Item[] {
    return Object.keys(BoxRequest.statuses).map((key: string): Item => {
      return {
        value: key,
        text: BoxRequest.statuses[key as BoxRequestStatusKey],
      };
    });
  }
}

type Item = {
  value: string;
  text: string;
};
